import { createSnapshotValue } from '../../lib/snapshot-value.ts'
export type Currency = 'EUR' | 'USD' | 'UAH'
type BankFile = { name: string; url: string }
export type ForeignPayment = {
  id: string
  supplier: string
  payerCompanyId: string
  invoiceNumber: string
  amount: string
  currency: Currency
  dueDate: string
  beneficiary: string
  bank: string
  iban: string
  swift: string
  files: BankFile[]
  history: string[]
}

export const FOREIGN_PAYMENTS: ForeignPayment[] = createSnapshotValue([] as ForeignPayment[])
